import {Stores} from "../stores";
import {SimpleToast} from "../stores/toast-store";
import {getServerUrl} from "../utils/global-config";
import {IRequestOptions} from "../utils/http-request";
import {createApiClient} from "./api";
import {AuthError} from "./auth-error";
import {HttpError} from "./http-error";

export function createAdminApi(stores: Stores) {
    async function getRequestOptions(): Promise<IRequestOptions> {
        const accessToken = await stores.authenticationStore.getOrRefreshToken();

        return {
            accessToken,
            baseUrl: getServerUrl(),
        };
    }

    function handleError(error: any) {
        if (error instanceof AuthError) {
            // eslint-disable-next-line no-console

            // MEMO:
            // discardToken() が上記のリダイレクト経路を直接発火させるため、非活性化。
            // 代わりに setSimpleToast(SimpleToast.SESSION_EXPIRED) だけを実行し、UI上で「ログイン」リンク付きトーストを表示。
            // console.error("AuthError occured");
            // stores.authenticationStore.discardToken();

            stores.toastStore.setSimpleToast(SimpleToast.SESSION_EXPIRED);
        } else if (error instanceof HttpError) {
            stores.toastStore.setHttpError(error);
        }
    }

    return createApiClient({getRequestOptions, handleError});
}
